// src/components/CustomRadioButton.js
import React from 'react';
import './CustomRadioButton.css';

const CustomRadioButton = ({ name, options, value, onChange }) => {
  return (
    <div className="custom-radio-group">
      {options.map((option, index) => (
        <label key={index} className={`custom-radio ${option.className}`}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default CustomRadioButton;
